module.exports = __webpack_public_path__ + "img/platform_logo.86ce127a.png";